export { default as ConnectFragmentDumb } from './connect-fragment-dumb';
